import {
  getStoreProjects,
  normalizeStoreUserId,
  sortedStoreProjectsForBuyerAccount,
} from "./service";

/** In-flight dedupe: one GET /store/projects per user per wave. */
let inFlightByUserKey = null;

export function clearStoreProjectsFetchCache() {
  inFlightByUserKey = null;
}

export function storeUserProjectsFetchKey(user) {
  const id = normalizeStoreUserId(user);
  return id != null ? `u:${id}` : null;
}

/** Buyers who use quote/cart flows (not dealer/admin/guest). */
export function shouldBootstrapStoreProjectsList(user) {
  if (!user?.mobile) return false;
  if (user.temp === true) return false;
  const mobile = String(user.mobile ?? "").toLowerCase();
  if (mobile.startsWith("guest_")) return false;
  if (user.dealer === true || user.admin === true) return false;
  if (
    typeof user.type === "string" &&
    user.type.toLowerCase().includes("dealer")
  ) {
    return false;
  }
  return true;
}

export function storeProjectsNavFlags(projects) {
  const list = Array.isArray(projects) ? projects : [];
  return {
    hasAnyOrder: list.some(
      (p) => String(p?.status ?? "").toLowerCase() !== "draft"
    ),
    hasAnyQuote: list.some(
      (p) => String(p?.status ?? "").toLowerCase() === "draft"
    ),
  };
}

/**
 * @param {object|null|undefined} user
 * @returns {Promise<object[]>}
 */
export async function fetchStoreProjectsListForUser(user) {
  const key = storeUserProjectsFetchKey(user);
  if (!key) return [];

  if (inFlightByUserKey?.key === key) {
    return inFlightByUserKey.promise;
  }

  const promise = (async () => {
    const res = await getStoreProjects();
    return sortedStoreProjectsForBuyerAccount(res?.data ?? res, user);
  })();

  inFlightByUserKey = { key, promise };
  try {
    return await promise;
  } finally {
    if (
      inFlightByUserKey?.key === key &&
      inFlightByUserKey?.promise === promise
    ) {
      inFlightByUserKey = null;
    }
  }
}
